export const PostStatus = Object.freeze({
  SUCCESSFUL: 'successful',
  SCHEDULED: 'scheduled',
  FAILED: 'failed',
  NOT_CONNECTED: 'notConnected',
})
